import { Gift } from 'lucide-react'

import { CopyButton } from '@/components/ui/CopyButton'
import {
  type ApplicationStep,
  InsuranceApplicationProgress,
  InsuranceApplicationProgressBar,
  InsuranceApplicationStepLine,
} from '../../InsuranceApplication/InsuranceApplicationProgress'
import { Demo, DsSection } from '../primitives'
import { MOCK_APPLICATION } from './insuranceApplicationMocks'

const WITH_ICON: ApplicationStep[] = [
  ...MOCK_APPLICATION.progress,
  { label: 'Start free trial', status: 'LOCKED', icon: Gift },
]

function Usage({ value }: { value: string }) {
  return (
    <div className="text-ink-400 mb-3 flex items-center gap-1 font-mono text-[10px]">
      <span>{value}</span>
      <CopyButton
        value={value}
        className="text-ink-400 hover:text-ink size-4 bg-transparent hover:bg-transparent"
      />
    </div>
  )
}

export function StepperSection() {
  return (
    <DsSection id="stepper" title="Stepper">
      <Demo label="InsuranceApplicationProgress" className="flex flex-wrap gap-16">
        <div className="w-50">
          <Usage value="<InsuranceApplicationProgress />" />
          <InsuranceApplicationProgress steps={MOCK_APPLICATION.progress} />
        </div>
        <div className="w-50">
          <Usage value="icon={Gift}" />
          <InsuranceApplicationProgress steps={WITH_ICON} />
        </div>
      </Demo>
      <Demo label="InsuranceApplicationStepLine" className="max-w-130">
        <Usage value="<InsuranceApplicationStepLine />" />
        <InsuranceApplicationStepLine steps={MOCK_APPLICATION.progress} />
      </Demo>
      <Demo label="InsuranceApplicationProgressBar">
        <Usage value="<InsuranceApplicationProgressBar />" />
        <InsuranceApplicationProgressBar percent={MOCK_APPLICATION.percentComplete} />
      </Demo>
    </DsSection>
  )
}
